import React, { ChangeEvent } from 'react'
import { Trans, t } from '@lingui/macro'
import { includes } from 'lodash'
import { Checkbox } from 'front-end/src/components'
import IconTick from '../../../components/common/icon/IconTick'
import Tags from '../../../components/common/tag/Tags'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import UserDetail from '../../../components/common/user/user-detail/UserDetail'
import UserMenu from './UserMenu'
import { useManageUsersPageContext } from '../ManageUsersPageContext'
import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { ManageUsersPageQuery } from '../ManageUsersPage.codegen'
import { TypeOfElement } from 'types/generic'

import './Item.less'

type User = TypeOfElement<
  NonNullable<
    NonNullable<ManageUsersPageQuery['admin']>['organisation']
  >['users']
>

export interface IPublicProps {
  user: User
  toggleAddGroupModal: (value: boolean) => void
}

const roleTitles = {
  ADMIN: <Trans>Full administrator</Trans>,
  MANAGER: <Trans>Workspace manager</Trans>,
  STUDENT: <Trans>General user</Trans>
}

export const Item: React.FC<IPublicProps> = (props) => {
  const { user } = props
  const { onRemoveFromGroup, toggleUserSelection, selectedUserIds } =
    useManageUsersPageContext()
  const { organisation_role, userIdentity, display_name, image_url } = user

  const onSelectionChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked
    toggleUserSelection && toggleUserSelection({ value, userId: user.id })
  }

  const renderCheckbox = () => {
    const checked = includes(selectedUserIds, user.id)

    return <Checkbox isChecked={checked} onChange={onSelectionChange} />
  }

  const { toggleAddGroupModal } = props

  return (
    <div className="ListItem UsersListItem">
      <div className="ListItem-checkbox">{renderCheckbox()}</div>
      <UserDetail
        display_name={display_name}
        imageUrl={image_url}
        meta={userIdentity}
        size={'normal'}
        onClick={() => {
          navigateTo(linkBuilder.userDetail(user.id))
        }}
      />
      <div className="ListItem-verified">
        {user.verified ? (
          <Tooltip text={t`Verified`}>
            <IconTick />
          </Tooltip>
        ) : (
          <Tooltip text={t`Not verified`}>
            <IconTick color="grey" />
          </Tooltip>
        )}
      </div>
      <div className="ListItem-groups">
        <Tags
          items={user.groups}
          onRemove={({ id: groupId }) =>
            onRemoveFromGroup && onRemoveFromGroup({ groupId, target: user.id })
          }
          onClick={({ id }) => navigateTo(linkBuilder.groupDetail(id))}
        />
      </div>
      <div className="ListItem-role">{roleTitles[organisation_role]}</div>
      <div className="ListItem-actions">
        <UserMenu user={user} onAddToGroup={() => toggleAddGroupModal(true)} />
      </div>
    </div>
  )
}
